import React from 'react';
import { Modal, ModalHeader, ModalBody, Button } from 'reactstrap';
import LottieAnimation from '../../../assets/animation/LottieAnimation';

const AudiencePreviewModal = ({ isOpen, toggle, isLoading, previewData, defineAudienceName, handleConfirm }) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle} centered className="modal-dialog modal-lg">
      <ModalHeader toggle={toggle}>Audience Definition Preview</ModalHeader>
      <ModalBody>
        {isLoading ? (
          <LottieAnimation />
        ) : (
          <>
            {previewData ? (
              <>
                <p><strong>Name:</strong> {defineAudienceName}</p>
                <p><strong>OS Type:</strong> {document.getElementById('defineOsTypeSelect').value}</p>
                <p><strong>User Status:</strong> {previewData.userStatus}</p>
                <p><strong>Definition:</strong> {previewData.definition}</p>
                <p><strong>Profiles:</strong> {previewData.profiles ? previewData.profiles.join(', ') : 'N/A'}</p>
                <p><strong>AIMEE Comments:</strong> {previewData.explain}</p>
                <div className="hstack gap-2 justify-content-end">
                  <Button color="secondary" onClick={toggle}>Cancel</Button>
                  <Button color="success" onClick={handleConfirm}>Confirm</Button>
                </div>
              </>
            ) : (
              <p>Preview data is not available.</p>
            )}
          </>
        )}
      </ModalBody>
    </Modal>
  );
};

export default AudiencePreviewModal;
